/* eslint-disable jsx-a11y/control-has-associated-label */
import Vimeo from "@u-wave/react-vimeo";

import React from "react";

import { observer } from "mobx-react";
import PropTypes from "prop-types";
import styled from "styled-components";

const StyledModal = styled.div`
  button {
    width: 33px;
    height: 33px;
    display: inline-block;
    position: absolute;
    top: -3.5rem;
    right: 0;
    opacity: 0.8;
    background-color: transparent;
    border: 0;
    z-index: 1;
  }

  button:after {
    transform: rotate(-45deg);
    position: absolute;
    top: -5px;
    left: 15px;
    width: 2px;
    height: 42px;
    content: " ";
    background-color: #fff;
  }

  button:before {
    transform: rotate(45deg);
    position: absolute;
    top: -5px;
    left: 15px;
    width: 2px;
    height: 42px;
    content: " ";
    background-color: #fff;
  }
`;

function VideoModal(props) {
  const { vimeoID, closeModal } = props;

  return (
    <StyledModal>
      <button onClick={closeModal} type="button" />
      <Vimeo responsive showTitle={false} video={vimeoID} />
    </StyledModal>
  );
}

VideoModal.defaultProps = {
  closeModal: () => {},
  vimeoID: "",
};

VideoModal.propTypes = {
  closeModal: PropTypes.func,
  vimeoID: PropTypes.string || PropTypes.number,
};

export default observer(VideoModal);
